/* istanbul ignore file */

import { Show } from 'framework/show';
import { ShowSection, SectionRow, FieldListLayout, ShowPageLayout } from 'framework/ui/layout';
import { EnumField, HtmlField, TextField } from 'framework/ui/field';
import useVacancyPublicationService, {
  UPDATE_VACANCY_PUBLICATION,
  VACANCY_PUBLICATION_PLATFORMS,
  VACANCY_PUBLICATION_STATUSES,
} from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';
import { useVacancyPublicationId } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';
import EditVacancyPublicationButton from 'domain/recruiting/vacancy/publication/shared/button/EditVacancyPublicationButton';
import DeleteVacancyPublicationButton from 'domain/recruiting/vacancy/publication/shared/button/DeleteVacancyPublicationButton';
import ViewVacancyPublicationPageMenu from 'domain/recruiting/vacancy/publication/Show/ViewVacancyPublicationPageMenu';
import SingleVacancyPublicationBreadcrumbs from 'domain/recruiting/vacancy/publication/shared/SingleVacancyPublicationBreadcrumbs';
import VacancyPublicationEntityHeader from 'domain/recruiting/vacancy/publication/shared/VacancyPublicationEntityHeader';
import VacancyLinkField from 'domain/recruiting/vacancy/shared/input/VacancyLinkField';
import VacancyPublicationDetailsField from 'domain/recruiting/vacancy/shared/field/VacancyPublicationDetailsField';
import VacancyPublicationField from 'domain/recruiting/vacancy/shared/field/VacancyPublicationField';

const ViewVacancyPublication = () => {
  const id = useVacancyPublicationId()!;
  const { getById } = useVacancyPublicationService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        buttons={[
          <EditVacancyPublicationButton
            key="edit-vacancy-publication"
            source="id"
            icon={<i className="fa fa-edit" />}
            permissionToCheck={UPDATE_VACANCY_PUBLICATION}
          />,
          <DeleteVacancyPublicationButton key="delete-vacancy-publication" />,
        ]}
        menu={<ViewVacancyPublicationPageMenu />}
        breadcrumbs={<SingleVacancyPublicationBreadcrumbs />}
        entityHeader={<VacancyPublicationEntityHeader />}
      >
        <ShowSection title="Vacancy publication information">
          <SectionRow>
            <VacancyLinkField source="vacancy.alias" label="Vacancy ID" />
            <TextField source="name" />
            <FieldListLayout source="englishLevels" label="Relevant english levels">
              <VacancyPublicationField />
            </FieldListLayout>
            <FieldListLayout source="countryOfResidences" label="Relevant country of residences">
              <VacancyPublicationField />
            </FieldListLayout>
            <EnumField source="type" label="Publication platform" options={VACANCY_PUBLICATION_PLATFORMS} />
            <EnumField source="status" label="Status" options={VACANCY_PUBLICATION_STATUSES} />
          </SectionRow>
        </ShowSection>
        <ShowSection title="Additional vacancy publication fields">
          <FieldListLayout source="formFields" hasSeparator>
            <VacancyPublicationDetailsField />
          </FieldListLayout>
        </ShowSection>
        <ShowSection title="Public description">
          <HtmlField source="description" label="" />
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default ViewVacancyPublication;
